<template>
  <div class="layout-header-container">
    <div class="layout-header-left">
      <img class="logo" :src="logoUrl" />
      <img class="dpLogo" :src="dpLogoUrl" />
    </div>
    <div v-if="isLoading" class="layout-header-user">
      <!-- Loading state -->
    </div>
    <div v-else-if="userId" class="layout-header-user">
      <el-dropdown trigger="click" @command="handleCommand">
        <!-- <span  v-if="vipEndAt==0">
          <img :src="avatar || userIcon">
        </span> -->
        <span
          class="el-dropdown-link"
          v-if="timestamp <= vipEndAt"
          @click="handleCommand"
        >
          <img :src="avatar || userIcon" />
          <img
            src="../../../../public/images/vipavatar.svg"
            class="vipavatar"
          />
        </span>
        <span v-else @click="handleCommand">
          <img :src="avatar || userIcon" />
        </span>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <el-dropdown-item class="user-dropdown-item" command="loginOut">
            <img :src="loginOutIcon" />
            <span>退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div v-else class="layout-header-right" @click="showLogin">登录/注册</div>
    <div v-if="userId" class="layout-header-period">
      <div class="period-item" @click="switchPeriod">
        <span>{{ isNewUser ? "点击此处设置学段和教授学科" : PerAndSub }}</span>
        <i class="period-qiehuan" />
      </div>
    </div>
    <el-dropdown class="org-dropdown" trigger="click" v-if="userInfo && userInfo.orgList && userInfo.orgList.length">
        <span class="el-dropdown-org">
          <span>{{ org && org.orgName }}</span>
          <img src="../../../assets/images/qiehuan.png" alt="">
        </span>
        <el-dropdown-menu slot="dropdown" class="org-dropdown-menu">
          <el-dropdown-item
            v-for="item in userInfo.orgList"
            :key="item.orgId"
            :class="{
              'is-active':org && org.orgId === item.orgId
            }"
            @click.native="handleOrgChange(item)"
          >
            {{ item.orgName }}
          </el-dropdown-item>
        </el-dropdown-menu>
    </el-dropdown>
    <div>
      <DialogUpdataInfo
        :dialogVisible="dialogVisible"
        @cloeseDialog="cloeseDialog"
      >
      </DialogUpdataInfo>
    </div>
  </div>
</template>

<script>
import { getLocalToken } from "@/utils/token";
import { mapGetters } from "vuex";
import sensors from "sa-sdk-javascript";
import { getUserInfo } from "@/api/user";
import { recordOrg } from "@/api/org";
import { uuid } from "@/utils/utils";
import DialogUpdataInfo from "./dialogUpdataInfo.vue";
export default {
  name: "LayoutHeader",
  components: { DialogUpdataInfo },
  data() {
    return {
      logoUrl: require("@/assets/images/laoshibang/logo.png"),
      dpLogoUrl: require("@/assets/images/laoshibang/dpLogo.png"),
      userIcon: require("@/assets/images/laoshibang/user-icon.png"),
      loginOutIcon: require("@/assets/images/laoshibang/loginOut-icon.png"),
      isLogin: true,
      vipEndAt: 0,
      timestamp: Math.floor(Date.now() / 1000),
      isLoading: true,
      isNewUser: false,
      dialogVisible: false,
    };
  },
  watch: {
    userInfo: {
      handler(newVal) {
        if (newVal) {
          console.log("UserInfo updated:", newVal);
          this.PerAndSub = newVal.periodName + newVal.subjectName;
          if (newVal.periodName === "" && newVal.subjectName === "") {
            this.isNewUser = true;
          } else {
            this.isNewUser = false;
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["userId", "userInfo", "avatar", "orgList", "org"]),
    orgName() {
      return this.org?.orgName;
    },
  },
  mounted() {
    console.log(getLocalToken("tal_token"), "getLocalToken");
    if (getLocalToken("tal_token")) {
      this.$store.commit("user/GET_USERINFO");
    }
    this.getUserInfo().finally(() => {
      this.isLoading = false;
    });
  },
  methods: {
    /**
     * 打开登陆页
     */
    showLogin() {
      this.$emit("showLogin");
    },
    /**
     * 退出登录
     */
    handleCommand(command) {
      switch (command) {
        case "loginOut":
          sensors.logout();
          sensors.identify(uuid());
          this.isLogin = false;
          this.$store.commit("user/LOGIN_OUT", this.$router);
          this.$store.commit("user/SET_ORG", null);
          break;
      }
    },
    getUserInfo() {
      return getUserInfo().then((res) => {
        if (res.code === 200) {
          const { vipEndAt, uid, orgList = [], curOrgId = null } = res.data;
          this.vipEndAt = vipEndAt;
          // 关联用户
          sensors.login(`login_user_${uid}`);
          if (orgList?.length) {
            const curOrg = orgList.find(item => item.orgId === curOrgId);
            this.$store.commit("user/SET_ORG", curOrg || orgList[0]);
          }
        }
      });
    },
    switchPeriod() {
      console.log(this.userInfo);
      this.dialogVisible = true;
    },
    cloeseDialog() {
      this.dialogVisible = false;
    },
    handleOrgChange(item) {
      recordOrg({
        orgId: item.orgId,
      })
      this.$store.commit('user/SET_ORG', item);
    }
  },
};
</script>
<style lang="scss" scope>
.layout-header-left {
  float: left;
  display: flex;
  height: 66px;
  align-items: center;
  .logo {
    /* width: 113px; */
    height: 25px;
    flex-shrink: 0;
    margin-left: 28px;
  }
  .dpLogo {
    width: 194px;
    height: 30px;
    flex-shrink: 0;
    margin-left: 12px;
  }
}
.layout-header-org {
  float: right;
  height: 66px;
  display: flex;
  margin-right: 42px;
}
.layout-header-period {
  float: right;
  height: 66px;
  display: flex;
  margin-right: 42px;
  .period-item {
    display: flex;
    justify-content: center;
    padding: 0 12px;
    height: 32px;
    margin-top: 15px;
    border-radius: 10px;
    cursor: pointer;
    background-color: #e2ebff;
    position: relative;
    span {
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 14px;
      line-height: 32px;
      letter-spacing: 0px;
      text-align: center;
      color: #0d70ed;
    }
  }
  .period-qiehuan {
    display: inline-block;
    width: 13px;
    height: 13px;
    margin-top: 10px;
    margin-left: 5px;
    background: url(../../../assets/images/qiehuan.png) no-repeat center center;
    background-size: cover;
  }
}

.layout-header-right {
  width: 105px;
  height: 46px;
  flex-shrink: 0;
  border-radius: 68px;
  background: #0d70ed;
  float: right;
  color: #fff;
  text-align: center;
  line-height: 46px;
  font-size: 14px;
  margin: 10px 25px 0px 0px;
  &:hover {
    cursor: pointer;
  }
}
.layout-header-user {
  margin: 10px 28px 0px 0px;
  float: right;
  flex-shrink: 0;
  &:hover {
    cursor: pointer;
  }
  img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
}
</style>
<style lang="scss" scoped>
.user-dropdown {
  width: 150px;
  height: 46px;
  top: 58px;
  left: 1742px;
  gap: 0px;
  border-radius: 10px;
  background: linear-gradient(180deg, #e2ebff -100%, #ffffff 64.13%);
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 15px;
    height: 15px;
    margin-right: 7px;
  }
  span {
    width: 57px;
    height: 20px;
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
  }
  .el-dropdown-menu__item {
    display: flex;
    align-items: center;
    span {
      white-space: nowrap;
    }
  }
}
// .el-dropdown-link ::before {
//     z-index: 3;
//     content: '';
//     position: absolute;
//     right: 0;
//     bottom: -17px;
//     width: 12px;
//     height: 12px;
//     background-image: url("../../../../public/images/vipavatar.svg");
//     background-size: cover;
// }
.el-dropdown-link {
  position: relative;
}
.vipavatar {
  position: absolute;
  bottom: -17px;
  left: 0;
}
.org-dropdown {
  float: right;
  margin-right: 42px;
  padding: 0 12px;
  height: 32px;
  margin-top: 15px;
  border-radius: 10px;
  cursor: pointer;
  background-color: #e2ebff;
  display: flex;
  justify-content: center;
}
.el-dropdown-org {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #0D70ED;
  img {
    width: 13px;
    height: 13px;
    margin-left: 5px;
  }
}
::v-deep .el-dropdown-menu__item:not(.is-disabled):hover,.el-dropdown-menu__item.is-active {
  color: #0D70ED;
}
</style>
